"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Spinner_1 = __importDefault(require("../../../../common/Spinner/Spinner"));
var Toast_1 = require("../../../../common/Toast");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var getLanguages_1 = require("../../../../lib/getLanguages");
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var Mutation_1 = require("../Graphql/Mutation");
var Queries_1 = require("../Graphql/Queries");
var GuideTable_1 = __importDefault(require("./GuideTable"));
function Guide(props) {
    var _a, _b, _c, _d;
    var t = (0, react_i18next_1.useTranslation)().t, organization = (0, org_hook_1.useOrg)().organization, _e = (0, react_1.useState)(false), clickStatus = _e[0], setClickStatus = _e[1], _f = (0, react_1.useState)({
        en: "",
        fr: "",
        rn: "",
    }), languages = _f[0], setLanguages = _f[1], _g = (0, react_1.useState)(null), editGuideParam = _g[0], setEditGuideParam = _g[1], _h = (0, react_1.useState)({
        loading: false,
        error: null,
        success: null,
    }), status = _h[0], setStatus = _h[1], _j = (0, react_1.useState)(""), categoryId = _j[0], setCategoryId = _j[1];
    var _k = (0, client_1.useLazyQuery)(Queries_1.GET_GUIDE_CATEGORY, {
        variables: { organization_id: organization.id },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        onCompleted: function () {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: false })); });
        },
        onError: function () {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: false })); });
        },
    }), callGuideCategory = _k[0], getCategoryList = _k[1], _l = (0, client_1.useLazyQuery)(Queries_1.GET_GUIDE, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    }), callGuide = _l[0], guideResponse = _l[1], _m = (0, client_1.useMutation)(Mutation_1.UPSERT_GUIDE, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    }), callUpsertGuide = _m[0], upsertGuideResponse = _m[1], _o = (0, client_1.useMutation)(Mutation_1.DELETE_GUIDE, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        refetchQueries: [Queries_1.GET_GUIDE_CATEGORY, "getGuideCategoryByOrganization"],
    }), callDeleteGuide = _o[0], deleteGuideResponse = _o[1];
    (0, react_1.useEffect)(function () {
        callGuideCategory();
        (0, getLanguages_1.getLanguages)().then(function (res) {
            setLanguages(res);
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (status === null || status === void 0 ? void 0 : status.success) {
            var timer_1 = setTimeout(function () {
                setStatus(function (prevState) { return (__assign(__assign({}, prevState), { success: null })); });
            }, 5000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [status === null || status === void 0 ? void 0 : status.success]);
    (0, react_1.useEffect)(function () {
        if (categoryId !== "" && organization.id !== "") {
            callGuide({
                variables: {
                    guide_category_id: categoryId,
                    organization_id: organization.id,
                },
            });
        }
    }, [categoryId, organization.id]);
    var reformatGuideParam = function () {
        var reformat = {
            id: null,
            title: JSON.stringify(languages),
            category: null,
            description: JSON.stringify(languages),
            thumbnail: languages,
            video: languages,
            sorting: null,
            organization_id: organization.id,
        };
        setEditGuideParam(reformat);
    }, getVal = function (obj) {
        var tmp = [];
        Object.keys(obj).forEach(function (key) {
            var lang = key, name = obj[key] === "" ? null : obj[key];
            tmp.push({
                lang: lang,
                name: name,
            });
        });
        return tmp;
    }, saveGuide = function (formData) {
        window.scrollTo(0, 0);
        setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        var thumbnailArr = getVal(formData.thumbnail), videoArr = getVal(formData.video), check_category = typeof formData.category === "object" && formData.category !== null
            ? formData.category.value
            : formData.category, variables = {
            title: formData.title,
            guide_category_id: check_category,
            guide_media: {
                thumbnail: thumbnailArr,
                video: videoArr,
            },
            description: formData.description,
            guide_id: formData.id,
            sorting: formData.sorting,
            organization_id: organization.id,
        };
        callUpsertGuide({
            variables: variables,
        })
            .then(function (res) {
            callGuideCategory();
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { success: res.data.upsertGuide, loading: false })); });
            reformatGuideParam();
        })
            .catch(function (e) {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: false })); });
            return e;
        });
    };
    var onGuideDelete = function (params) {
        callDeleteGuide({
            variables: {
                id: params.id,
                organization_id: organization.id,
                guide_category_id: params.guide_category_id,
            },
        });
    }, onGuideEdit = function (params) {
        window.scrollTo(0, 0);
        var reformat = {
            id: params.id,
            title: params.title,
            category: params.guide_category_id,
            description: params.description,
            thumbnail: languages,
            video: languages,
            sorting: params.sorting,
            organization_id: organization.id,
        };
        setEditGuideParam(reformat);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ((deleteGuideResponse === null || deleteGuideResponse === void 0 ? void 0 : deleteGuideResponse.loading) ||
            status.loading ||
            (upsertGuideResponse === null || upsertGuideResponse === void 0 ? void 0 : upsertGuideResponse.loading)) && react_1.default.createElement(Spinner_1.default, null),
        (deleteGuideResponse === null || deleteGuideResponse === void 0 ? void 0 : deleteGuideResponse.data) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t("deleted successfully"), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        ((_a = upsertGuideResponse === null || upsertGuideResponse === void 0 ? void 0 : upsertGuideResponse.data) === null || _a === void 0 ? void 0 : _a.upsertGuide) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t((_b = upsertGuideResponse === null || upsertGuideResponse === void 0 ? void 0 : upsertGuideResponse.data) === null || _b === void 0 ? void 0 : _b.upsertGuide), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        react_1.default.createElement(HeaderBar_1.default, { hideSave: true, title: "guide" },
            react_1.default.createElement(GuideTable_1.default, { list: (_d = (_c = getCategoryList === null || getCategoryList === void 0 ? void 0 : getCategoryList.data) === null || _c === void 0 ? void 0 : _c.getGuideCategoryByOrganization) !== null && _d !== void 0 ? _d : [] }))));
}
exports.default = Guide;
